import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StatesService } from '../../../services/states.service';
import { FormsByStatesDataModel } from '../../../variables/states';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../../../services/auth.service';
import { PdfService } from '../../../services/pdf.services';
import { UploadModel, UploadResultModel } from '../../../variables/customer';
import { Location } from '@angular/common';

const uploadPdf = async (pdfService: PdfService, fileName: string, obj: FormData): Promise<any> => {

  let response = await pdfService.uploadPdfFile(fileName, obj)
    .toPromise()
    .catch(error => {
      if (error instanceof Object) {
        if (error["message"] != "") {
          alert(error["message"]);
        }
      }
      console.log(error);
    });
  if (response instanceof Object) {
    if (response["message"] != "" && response["message"] != undefined) {
      // alert(response["message"]);
    }
    if (response instanceof Object) {
      let result = response["result"];

      return result;
    }
    return null;
  }

}

const afterUploadPdf = async (pdfService: PdfService, obj: UploadModel): Promise<UploadResultModel> => {

  let response = await pdfService.afterUploadPdf(obj)
    .toPromise()
    .catch(error => {
      if (error instanceof Object) {
        if (error["message"] != "") {
          alert(error["message"]);
        }
      }
      console.log(error);
    });
  if (response instanceof Object) {
    if (response["message"] != "" && response["message"] != undefined) {
      alert(response["message"]);
    }
    let result = <UploadResultModel>response["result"];

    return result;
  }

}


const getFormById = async (statesService: StatesService, id: number): Promise<FormsByStatesDataModel> => {

  let response = await statesService.getFormById(id)
    .toPromise()
    .catch(error => {
      if (error instanceof Object) {
        if (error["message"] != "") {
          alert(error["message"]);
        }
      }
      console.log(error);
    });
  if (response instanceof Object) {
    if (response["message"] != "" && response["message"] != undefined) {
      alert(response["message"]);
    }
    if (response instanceof Object) {
      if (response["message"] != "" && response["message"] != undefined) {
        alert(response["message"]);
      }
      let result = <FormsByStatesDataModel>response["result"];

      return result;
    }
    return null;
  }

}



@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})
export class UploadComponent implements OnInit {
  formId: number = null;
  formName: string = "";
  state: string = "";

  selectedFile: any = null;
  destinationFile: SafeResourceUrl;

  consentForm: UntypedFormGroup;
  consentSubmitted: boolean = false;

  isSummary: boolean = false;
  dateTimeNow: Date = new Date();
  newFileName: string = "";
  referenceNumber: string = "";
  emailRecipient: string = "";

  frmData: FormData = new FormData();
  isLoading: boolean = false;
  additionalPdfFile: any = null;
  attachAdditionalPdf: boolean = false;
  
  constructor(
    private formBuilder: UntypedFormBuilder,
    private statesService: StatesService,
    private authService: AuthService,
    private pdfService: PdfService,
    public sanitizer: DomSanitizer,
    private activeModal: NgbModal,
    route: ActivatedRoute,
    router: Router,
    public location: Location
  ) {
    this.formId = parseInt(route.snapshot.params["id"]);

    if (this.formId != undefined && this.formId != null) {
      getFormById(statesService, this.formId).then(data => {
        if (data != undefined && data != null) {
          this.state = data.state;
          this.formName = data.form;

          // Check if this is AZ 5000HC form
          this.attachAdditionalPdf = (this.state === 'AZ' && this.formName === '5000HC' && this.formId == 150) ||
            (this.state === 'CT' && this.formName === 'CERT119' && this.formId == 48) ||
            (this.state === 'MA' && this.formName === 'ST5' && this.formId == 80) ||
            (this.state === 'MI' && this.formName === '3372' && this.formId == 2) ||
            (this.state === 'MI' && this.formName === '3372' && this.formId == 66) ||
            (this.state === 'MO' && this.formName === '149' && this.formId == 3) ||
            (this.state === 'PA' && this.formName === 'REV_1220' && this.formId == 7) ||
            (this.state === 'PA' && this.formName === 'REV_1220' && this.formId == 244) ||
            (this.state === 'SD' && this.formName === 'STREAMLINE' && this.formId == 138) ||
            (this.state === 'SD' && this.formName === 'STREAMLINE' && this.formId == 137) ||
            (this.state === 'WA' && this.formName === '360001' && this.formId == 246);

          this.consentForm = this.formBuilder.group({
            hasConsent: [false, Validators.requiredTrue]
          });
        }
        else {
          router.navigate(["/eCert/certificates"]);
        }
      });
    }
  }

  ngOnInit(): void {
  }

  get cf() { return this.consentForm.controls; }

  onFileChange(event) {
    this.frmData.delete('file');
    let file = event.target.files[0];
    const element = event.currentTarget as HTMLInputElement;

    if (file && file.type !== "application/pdf") {
      alert("Please upload a PDF file");
      element.value = ""; // Clear the selected file
    } else {
      if (file != "") {
        this.selectedFile = file;
        let urlToBlob = window.URL.createObjectURL(file);
        this.destinationFile = this.sanitizer.bypassSecurityTrustResourceUrl(urlToBlob);
        this.frmData.append('file', file);
        
        // Call method to check File API immediately after file selection
        this.checkFileApi(file);
      }
      else {
        this.destinationFile = null;
      }
    }
  }

  onAdditionalPdfChange(event) {
    let file = event.target.files[0];
    const element = event.currentTarget as HTMLInputElement;

    if (file && file.type !== "application/pdf") {
      alert("Please upload a PDF file");
      element.value = ""; // Clear the selected file
    } else {
      if (file != "") {
        this.additionalPdfFile = file;
        this.frmData.append('attachedFile', file);
      }
    }
  }

  checkFileApi(file: File): void {
    this.checkPdfPasswordProtection(file);
  }

  checkPdfPasswordProtection(file: File): void {
    const formData = new FormData();
    formData.append('file', file);
    
    this.pdfService.ispdfpasswordprotected(formData).subscribe(
      (response: any) => {
        console.log('PDF Password Protection Check:', response);
        
        // Handle the response based on your API structure
        if (response && response.result !== undefined) {
          const isPasswordProtected = response.result;
          if (isPasswordProtected) {
            alert('This PDF file is password protected. Please upload an unprotected PDF file.');
            // Clear the selected file
            this.selectedFile = null;
            this.destinationFile = null;
            this.frmData.delete('file');
            console.log(this.selectedFile);
            // Reset file input and clear PDF object
            const fileInput = document.querySelector('object[type="application/pdf"]') as HTMLInputElement;
            if (fileInput) {
              fileInput.removeAttribute('data');
            }
          }
        }
      },
      (error) => {
        console.error('Error checking PDF password protection:', error);        
        this.selectedFile = null;
        this.destinationFile = null;
        this.frmData.delete('file');
        console.log(this.selectedFile);
        // Reset file input and clear PDF object
        const fileInput = document.querySelector('object[type="application/pdf"]') as HTMLInputElement;
        if (fileInput) {
          fileInput.removeAttribute('data');
        }
      }
    );
  }

  openModalConsent(modal) {
    if(this.additionalPdfFile == null && this.attachAdditionalPdf == true)
      {
        alert("Please attach additional PDF");
        return;
      }
    this.activeModal.open(modal, { centered: true, size: 'lg', scrollable: true, ariaLabelledBy: 'consentModalTitle' });
  }

  closeModal() {
    this.activeModal.dismissAll();
  }

  onConsentSubmit() {
    this.consentSubmitted = true;
    if (this.consentForm.invalid) {
      return;
    }
    else {
      this.activeModal.dismissAll();
      this.submitForm();
    }
  }

  submitForm() {
    this.isLoading = true;
    let dateNow: Date = new Date();
    let ts: string = dateNow.getFullYear().toString() + dateNow.getMonth().toString() + dateNow.getDate().toString();
    ts += "_" + dateNow.getHours().toString() + dateNow.getMinutes().toString() + dateNow.getSeconds().toString();
    this.newFileName = this.authService.getCustomerNumber() + "_" + this.formName + "_" + ts + ".pdf";
    this.dateTimeNow = dateNow;
    this.emailRecipient = this.authService.getEmail();
    let obj: UploadModel = <UploadModel>{
      fileName: this.newFileName,
      dateSubmitted: this.dateTimeNow,
      formId: this.formId,
      formName: this.formName,
      additionalPdf: this.additionalPdfFile
    };

    uploadPdf(this.pdfService, this.newFileName, this.frmData).then(data => {
      if (data != "" && data != undefined) {
        afterUploadPdf(this.pdfService, obj).then(data => {
          this.isLoading = false;
          if (data != null && data != undefined) {
            this.referenceNumber = data.referenceNumber;
            this.isSummary = true;
            this.isLoading = false;
          }
        }, () => {
          this.isLoading = false;
        });
      } else {
        this.isLoading = false;
      }
    }, () => {
      this.isLoading = false;
    });
  }
}
